<div *ngIf="previousVisible && !nextVisible || !previousVisible && nextVisible;else both_visible">
  <div class="o-flex o-flex--grids mt-5 navigation-buttons">
    <div class="o-flex__item u-flex-1/1@desktop u-flex-1/1@tablet u-flex-1/1@small text-center">
      <div class="navigation-buttons__group">
        <div *ngIf="previousVisible" class="c-button c-button--primary u-margin-bottom pl-5 pr-5"
             appThrottleClick (clickFunction)="previousClicked()">{{previousLabel}}</div>

        <div *ngIf="nextVisible && nextEnabled ; else next_grey" class="c-button c-button--primary u-margin-bottom pl-5 pr-5"
             appThrottleClick (clickFunction)="nextClicked()">{{nextLabel}}</div>
        <ng-template #next_grey>
          <div *ngIf="nextVisible" class="c-button c-button--default u-margin-bottom pl-5 pr-5" style="pointer-events: none">{{nextLabel}}</div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #both_visible>
  <div class="o-flex o-flex--grids mt-5 navigation-buttons">
    <div class="o-flex__item u-flex-1/2@desktop u-flex-1/2@tablet u-flex-1/1@small text-right">
      <ng-container *ngIf="previousEnabled; else grey_out_prev_button">
        <div class="c-button c-button--secondary u-margin-bottom pl-5 pr-5"
             appThrottleClick (clickFunction)="previousClicked()">{{previousLabel}}</div>
      </ng-container>
      <ng-template #grey_out_prev_button>
        <a href="#" class="c-button c-button--default c-button--big u-margin-bottom text-semibold">{{previousLabel}}</a>
      </ng-template>
    </div>

    <div class="o-flex__item u-flex-1/2@desktop u-flex-1/2@tablet u-flex-1/1@small text-left">
      <ng-container *ngIf="nextEnabled;else grey_out_next_button">
        <div class="c-button c-button--primary u-margin-bottom pl-5 pr-5" appThrottleClick (clickFunction)="nextClicked()">{{nextLabel}}</div>
      </ng-container>
      <ng-template #grey_out_next_button>
        <div class="c-button c-button--default u-margin-bottom pl-5 pr-5" style="pointer-events: none">{{nextLabel}}</div>
      </ng-template>
    </div>
  </div>
</ng-template>

